import React from 'react'
import ats from './data'
import { Link } from 'react-router-dom';

  const social = ats.social;
  const {services, company, legal} = ats.nav;
  const info = ats.info;
  const currentYear = new Date().getFullYear();
  
export default function FooterAts() {
    return (
      <footer aria-labelledby="footer-heading" className="bg-gray-900">
        <h2 id="footer-heading" className="sr-only">{ats.name}</h2>
        <div className="mx-auto max-w-7xl px-6 pb-8 pt-8 sm:pt-24 lg:px-8 lg:pt-16">
          <div className="grid grid-cols-1 lg:grid-cols-2 text-left gap-8">
            <div className="space-y-2">
              <img
                alt="Company name"
                src={process.env.PUBLIC_URL + "/static/atsauto_logo_sm.png"}
                className="h-14"
              />
              <h4 className="text-lg font-semibold leading-6 text-white">{info.name}, LLC</h4>
              <div className='space-y-6'>
                <p className="text-sm text-gray-200 max-w-md">
                Your trusted used car dealership for quality affordable vehicles in the Denver Metro Area.
                </p>
                <p className="text-lg leading-6 text-gray-100 font-bold">
                {info.address1} <br/>{info.address2}
                </p>
                <p className="text-base leading-6 text-gray-200 font-bold">
                <a href={`tel:${info.tel}`}>{info.tel}</a><br/>
                <a href={`mailto:${info.email}`}>{info.email}</a>
                </p>
              </div>
            </div>
            <div className="my-8 grid grid-cols-3 justify-start">
                <div className="mt-10 md:mt-0">
                  <h3 className="text-sm font-semibold leading-6 text-white">Services</h3>
                  <ul className="mt-6 space-y-4">
                    {services.map((item) => (
                      <li key={item.name}>
                        <Link to={item.href} className="text-sm leading-6 text-gray-300 hover:text-white">
                          {item.name}
                        </Link>
                      </li>
                    ))}
                  </ul>
              </div>
              <div className="mt-10 md:mt-0">
                  <h3 className="text-sm font-semibold leading-6 text-white">Company</h3>
                  <ul className="mt-6 space-y-4">
                    {company.map((item) => (
                      <li key={item.name}>
                        <Link to={item.href} className="text-sm leading-6 text-gray-300 hover:text-white">
                          {item.name}
                        </Link>
                      </li>
                    ))}
                  </ul>                
              </div>
              <div className="mt-10 md:mt-0">
                  <h3 className="text-sm font-semibold leading-6 text-white">Legal</h3>
                  <ul className="mt-6 space-y-4">
                    {legal.map((item) => (
                      <li key={item.name}>
                        <Link to={item.href} className="text-sm leading-6 text-gray-300 hover:text-white">
                          {item.name}
                        </Link>
                      </li>
                    ))}
                  </ul>
              </div>
            </div>
          </div>
          <div className='my-4 text-center'>
          <div className="flex space-x-6 justify-center">
                {social.map((item) => (
                  <Link key={item.name} to={item.href} target='_blank' className="text-gray-500 hover:text-gray-400">
                    <span className="sr-only">{item.name}</span>
                    <item.icon aria-hidden="true" className="h-6 w-6" />
                  </Link>
                ))}
              </div>
          </div>
          <div className="mt-8 border-t border-white/10 pt-8 text-center">
            <p className="text-xs leading-5 text-gray-400">&copy; {currentYear} {info.name}, LLC. ATS Auto Detail, LLC. All names and rights reserved.</p>
          </div>
        </div>
      </footer>
    )
  }
  